




















import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class ErrorPageDetails extends Vue {
  @Prop()
  public readonly status!: string;

  @Prop()
  public readonly message!: string;

  @Prop()
  public readonly notified!: boolean;

  get year () {
    return (new Date()).getFullYear()
  }
}
